import { FaLock } from "react-icons/fa";
import { BiBookOpen } from "react-icons/bi";
import {
  RiStore2Line,
  RiFileList3Line,
  RiHome5Line,
  RiMegaphoneLine
} from "react-icons/ri";
import { Link } from "react-router-dom";
import { useOnboard } from "../../../hooks/OnboardContext";
import { i18n } from "../../../localization/i18n";
import { customerSituations } from "../../../utils/constants";
import { RouteButton } from "../styles";

interface MenuListProps {
  toggleMenu: () => void;
}

export const FixiterMenuList = ({ toggleMenu }: MenuListProps) => {
  const { licensee, planHasExpired } = useOnboard();

  return (
    <>
      <Link
        onClick={toggleMenu}
        to={
          licensee?.completed_onboard &&
          licensee?.situation !== customerSituations.onboarding &&
          !planHasExpired
            ? "/fixiter/dashboard"
            : "/fixiter/dashboard"
        }
      >
        <RouteButton
          disabled={
            !licensee?.completed_onboard ||
            licensee?.situation === customerSituations.onboarding ||
            planHasExpired
          }
        >
          <FaLock
            className="is_over"
            size={16}
            display={licensee?.completed_onboard ? "none" : ""}
          />
          <RiHome5Line size={28} />
          <span>{`${i18n.t("sidebar.home") || "Início"}`}</span>
        </RouteButton>
      </Link>

      {licensee?.completed_onboard &&
      licensee?.situation !== customerSituations.onboarding &&
      !planHasExpired ? (
        <a
          onClick={toggleMenu}
          href="http://loja.usefixit.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <RouteButton disabled={false}>
            <FaLock className="is_over" size={16} display="none" />
            <RiStore2Line size={28} />
            <span>{`${i18n.t("sidebar.store") || "Loja"}`}</span>
          </RouteButton>
        </a>
      ) : (
        <RouteButton disabled={true}>
          <FaLock className="is_over" size={16} />
          <RiStore2Line size={28} />
          <span>{`${i18n.t("sidebar.store") || "Loja"}`}</span>
        </RouteButton>
      )}

      <Link
        onClick={toggleMenu}
        to={
          licensee?.completed_onboard &&
          licensee?.situation !== customerSituations.onboarding &&
          !planHasExpired
            ? "/fixiter/courses"
            : "/fixiter/dashboard"
        }
      >
        <RouteButton
          disabled={
            !licensee?.completed_onboard ||
            licensee?.situation === customerSituations.onboarding ||
            planHasExpired
          }
        >
          <FaLock
            className="is_over"
            size={16}
            display={!licensee?.completed_onboard ? "" : "none"}
          />
          <BiBookOpen size={28} />
          <span>{`${i18n.t("sidebar.courses")}`}</span>
        </RouteButton>
      </Link>

      {licensee?.completed_onboard &&
      licensee?.situation !== customerSituations.onboarding &&
      !planHasExpired ? (
        <a
          onClick={toggleMenu}
          href="https://usefixit.com.br/" // REPLACE WITH MARKETING LINK LATER
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <RouteButton disabled={false}>
            <FaLock className="is_over" size={16} display="none" />
            <RiMegaphoneLine size={28} />
            <span>{`${i18n.t("sidebar.marketing") || "Marketing"}`}</span>
          </RouteButton>
        </a>
      ) : (
        <RouteButton disabled={true}>
          <FaLock className="is_over" size={16} />
          <RiMegaphoneLine size={28} />
          <span>{`${i18n.t("sidebar.marketing") || "Marketing"}`}</span>
        </RouteButton>
      )}

      <Link
        onClick={toggleMenu}
        to={
          licensee?.completed_onboard &&
          licensee?.situation !== customerSituations.onboarding &&
          !planHasExpired
            ? "/fixiter/certificate"
            : "/fixiter/dashboard"
        }
      >
        <RouteButton
          disabled={
            !licensee?.completed_onboard ||
            licensee?.situation === customerSituations.onboarding ||
            planHasExpired
          }
        >
          <FaLock
            className="is_over"
            size={16}
            display={!licensee?.completed_onboard ? "" : "none"}
          />
          <RiFileList3Line size={28} />
          <span>{`${i18n.t("sidebar.certificate") || "Certificado"}`}</span>
        </RouteButton>
      </Link>
    </>
  );
};
